import DatePicker from 'vue2-datepicker'
import moment from 'moment-timezone';
import agent from '../service'
import custom  from '@/custom'
import _ from 'lodash'
// import { LangStatus } from '@/service/i18n';

//restful api
import { signalr } from '@/service'
import { agent as webcastle } from '@/service/api/webcastle'

const default_opt = () => ({
  perPage: 15, //limit,
  currentPage: 1,
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {}
})
const i18n_fields = {
  EN: [
    { key: 'id', label: '#.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'group', label: 'Group' },
    // { key: 'is_alive', label:'Agent On/Off'},   //Todo : agent On/Off 유무 | 통신이 불안정해서 on/off 표시를 하지 못함.
    { key: 'nickname', label: 'Nickname' },
    { key: 'server', label: 'Server' }, // name[host]@ip_addr
    { key: 'mode', label: 'Firewall Mode'},
    { key: 'domain', label: 'Domain', thStyle: 'width: 20%'},
    { key: 'version', label : 'Version' },
  ],
  KO: [
    { key: 'id', label: '#.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'group', label: '그룹' },
    // { key: 'is_alive', label:'에이전트 On/Off'},   //Todo : agent On/Off 유무
    { key: 'nickname', label: '이름' },
    { key: 'server', label: '서버' }, // name[host]@ip_addr
    { key: 'mode', label: '방화벽 모드'},
    { key: 'domain', label: '도메인', thStyle: 'width: 20%'},
    { key: 'version', label : '버전' },
  ]
}

const i18n_domain = {
  EN: [
    { key: 'domain', thStyle: 'width: 10%', label: 'domain'},
    { key: 'mode', thStyle: 'width: 5%', label: 'mode' },
    { key: 'level', thStyle: 'width: 5%', label: 'level' },
  ],
  KO: [
    { key: 'domain', thStyle: 'width: 10%', label : '도메인' },
    { key: 'mode', thStyle: 'width: 5%', label : '모드' },
    { key: 'level', thStyle: 'width: 5%', label : '레벨' },
  ]
}

export default {
  name: 'agentList',
  props: ['only_select', 'list_selected', 'agent_id', 'manage_id'],
  watch: {
    list_selected() {
      let id_list = this.list_selected.map(r => r.id)
      this.module_list.forEach(r => {
        r.check = id_list.indexOf(r.id) > -1 ? true : false
      })
      this.selected = id_list
      console.info("list_selected watch updated props data", this.selected.length)
    },
  },
  components : { DatePicker },
  data: () => ({
    // like wsfinder
    filter_is_del : true,
    modal_multi : false,
    custom,
    selected : [],
    module_list : [],
    // default
    // modify_nickname : '',
    // nickname_info : '',
    // nickname_modify_modal : false,
    // update_nickname : {},
    wc_copy_text : "copy",
    strArray : '',
    copy_text : "copy",
    show: false,
    so : default_opt(),
    modal_domain : false,
    modal_domain_info : {},
    modal_del : false,
    del_info : {},
    del_nickname : '',
    th : undefined,
    pong : { list : [], cnt : 12 },
  }),
  computed: {
    domain_manage_fields: function () {
      return i18n_domain[this.i18n]
    },
    fields() { return i18n_fields[this.i18n]; },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    mode_count(item, opt = { mode : 1 }) { return item.policy.domains && item.policy.domains.length ? _.filter(item.policy.domains, opt).length : 0 },
    // extra function
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.check) { return 'table-success' }
    },
    multi_click(record, index) {
      try{
        if(this.agent_id === undefined) {
          // 해당 값이 없으면 디테일로 변경
          return this.detail(record)
        }
        if(this.agent_id == record.id) { return this.$toastr.w("An agent from which to import settings") }
        this.multi_one(!record.check, { item: record }, false)
        console.debug("select", index)
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_one(value, row) {
      try {
        if(this.only_select != true) {
          return console.log("not selecting")
        }

        if(this.agent_id == row.item.id) { return this.$toastr.w("An agent from which to import settings") }
        else if(row.item.manage_id && row.item.manage_id > 0 && row.item.manage_id != this.manage_id) {
          return this.$toastr.w("Managed by multiplexing settings")
        }
        this.$parent.$emit("multi_one", { id: row.item.id, nickname: row.item.nickname, is_del: !value });
        if(!value) { this.selected = _.pull(this.selected, row.item.id) }
        else {
          this.selected.push(row.item.id)
        }
        this.selected = _.uniq(this.selected)
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_all() {
      try {
        this.module_list.forEach(r => {
          if(this.agent_id == r.id) { console.log("An agent from which to import settings"); return }
          else if(r.manage_id) { console.log("is already set policy"); return }
          else { r.check = true; this.selected.push(r.id) }
        })

        this.selected = _.uniq(this.selected)
        this.$parent.$emit("multi_all", _.uniq(this.module_list.map(r => { if(this.agent_id != r.id) { return { nickname: r.nickname, id: r.id } } })))
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_clear() {
      this.$parent.$emit("multi_clear", []); this.module_list.forEach(r => r.check = false)
      this.$refs._wc_agent_list ? this.$refs._wc_agent_list.clearSelected() : ''
      this.selected = []
    },
    // default function
    // async nickname_modify() {
    //   try{
    //     if(!this.modify_nickname) { return this.$toastr.w("require new nickanme") }
    //     let body =  Object.assign({}, this.update_nickname, { nickname : this.modify_nickname, policy : undefined })
    //     let rs = await Api.Manager_Call('agent', 'update', body);
    //     if(rs.error) { return this.$toastr.e("update failed") }
    //     this.update_nickname = {};
    //     this.modify_nickname = '';
    //     this.$toastr.i("Success.")
    //     this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''
    //   } catch(e) { console.log(e) }
    // },
    refresh() { console.log('refresh', this.$refs._wc_agent_list ? 'DOM have table' : '-'); this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''; if(!this.th) { this.th = setTimeout(() => this.refresh, 3000); }},
    reset() { this.so = default_opt(); this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''},
    hideList(e) { this.show = !e; console.log('agent.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') },
    Download(){ this.$router.replace(`/downloads/`); },
    async ping(){
      if(this.th) { clearTimeout(this.th); }
      if(!(this.module_list && this.module_list.length)) { return }
      (this.module_list || []).forEach(r => agent.Cmd("ping", r.id));
      this.th = setTimeout(this.ping, 3000)
    },
    remove() {
      this.del_nickname = this.del_nickname.trim()
      if(this.del_info.nickname != this.del_nickname) { return this.$toastr.e('Invalid server name entered');  }
      // Api.Manager_Call('webcastle.agent', 'delete', { id : this.del_info.id }).then(() => {
        webcastle.deleteAgent({ id : this.del_info.id }).then(() => {
        this.$toastr.i('Deleted successfully');
        this.refresh()
      }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
      this.del_info = {};
      this.del_nickname = '';
      this.modal_del = true;
    },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [{name : 'id', op : 'desc'}] } }

      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      if(this.filter_is_del){ search.body.and.push({ name : 'is_del', value : false, op : '=' }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'mode' : search.body.and.push({name: 'mode', value: Number(value) , op: '=' }); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: `%${value}%`, op: 'like' }); break;
        }
      }
      try{
        let rs = await webcastle.listAgent(search);
        if(rs.error) { return this.$toastr.e("load failed") }
        this.so.totalRows = rs.total;
        this.module_list =  _.map(rs.body, r => { try { r.check = this.selected.indexOf(r.id) > -1; r.policy = JSON.parse(r.policy); } catch (e) { console.log("policy parser issue") } return r });
        this.show = this.so.totalRows > 0 ? true : false;
        this.ping()
        // setTimeout(() => this.ping, 3000);
        this.$parent.$emit('count', this.so.totalRows)
        this.$parent.$emit('agent_list', this.module_list)

        // 초기 선택을 위함
        if(this.list_selected) {
          let id_list = this.list_selected.map(r => r.id)
          this.module_list.forEach(r => {
            r.check = id_list.indexOf(r.id) > -1 ? true : false
          })
          this.selected = id_list
          console.info("list_selected watch updated props data", this.selected.length)
        }
        return this.module_list;
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    detail: function(item) {
      this.signalr && this.signalr.off('webcastle');

      // Todo : 호환성을 위해 template 을 나눠줘야함.
      // 하위 : module / 상위 : agent.
      this.$router.push(`modules/v2/${item.id}`); // 하위 호환용
    },
    res(m) {
      if(m.cmd == 'pong') {
        // console.log('m.agent_id', m.agent_id)
        _.indexOf(this.pong.list, m.agent_id) == -1 ? this.pong.list.push(m.agent_id) : ''
      }
    },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created: function() {
    // if(this.only_select != true) { i18n_fields[localStorage['UWSS_MANAGER_LANG']].push({ key: 'select', label: 'More' }) }
    console.log('modules.list.vue', 'created');
  },
  destroyed: function() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    signalr.off('webcastle', this.res);
    console.info('modules.list.vue', 'destroyed');
  },
  mounted: function() {
    console.info('modules.list.vue', 'mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    signalr.on('webcastle', this.res)
    },
}